import React from 'react'
import { connect } from 'react-redux'
import Login from './Login'
import querystring from 'querystring'
import { authorizeCode } from './../../../../store/token/actions'
import { addError } from './../../../../store/errors/actions'
import AuthorizingCode from './AuthorizingCode'
import { Redirect } from 'react-router'

const mapStateToProps = (state, props) => {
  return {
    authToken: state.token,
  }
}

const mapDispatchToProps = dispatch => ({
  authorizeCode: code => dispatch(authorizeCode(code)),
  //authorizeError: error => dispatch(authorizeError(error)),
  addError: error => dispatch(addError(error)),
})

const LoginContainer = props => {

  if (props.authToken)
    return <Redirect to="/select-repository" />

  // This may be Github specific responses
  const query = querystring.parse(props.queryString)

  if (query.error){
    var error = new Error(query['error_description'])
    error.code = query['error']
    error.uri = query['error_uri']
    props.addError(error)
    return null
  }

  if (query.code){
    props.authorizeCode(query.code)
    return <Redirect to={`/authorizing`} />
  }

  if (!props.authToken)
    return <Login />


}

export default connect(mapStateToProps, mapDispatchToProps)(LoginContainer)



// WEBPACK FOOTER //
// ./src/pages/Login/LoginContinue/Login/Container.js